import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from "@mui/material";
import { useState } from "react";
import DialogInfoDadosPropriedade from "./DialogInfoDadosPropriedade";

export default function InfoDadosPropriedade({
    resposta
}: InfoDadosPropriedadeProps) {

    const [openModal, setOpenModal] = useState<null | TInfoDadosPropriedade>(null);
    return (
        <>
            <TableContainer>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <b>Nome</b>
                            </TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {resposta.propriedades.map((item, index) => (
                            <TableRow 
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{item.nome}</TableCell>
                                <TableCell>
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="flex-end"
                                    >
                                        <Button
                                            onClick={() => setOpenModal(item)}
                                        >Ver detalhes</Button>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {
                Boolean(openModal) && openModal &&
                <DialogInfoDadosPropriedade
                    open={Boolean(openModal)}
                    onClose={() => setOpenModal(null)}
                    dadosPropriedade={openModal}
                />
            }
        </>
    )
}

interface InfoDadosPropriedadeProps {
    resposta: {
        propriedades: TInfoDadosPropriedade[]
    }
}

export type TInfoDadosPropriedade = {
    nome: string;
    propriaProp: string;
    tamanho: string;
    arrendatario: string;
    vencimentoContrato: string;
    leite: {
        produtor: string;
        mediaDiaria: string;
        qtdVacas: string;
        valor: string;
    };
    cafe: {
        produtor: string;
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    milho: {
        produtor: string;
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    soja: {
        produtor: string;
        qtdSacas: string;
        qtdHa: string;
        valor: string;
    };
    gadoCorte: {
        produtor: string;
        qtdCabecas: string;
        raca: string;
        valor: string;
    };
    outraCultura: {
        produtor: string;
        nome: string;
        producaoEstimada: string;
        valor: string;
    };
    outraRenda: {
        produtor: string;
        nome: string;
        valor: string;
    };
}
